import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0d0d0d",
            color: "#ffffff",
            border: "1px solid rgba(255,255,255,0.12)",
            borderRadius: 0,
            fontFamily: "IBM Plex Sans, system-ui, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
